import {Route} from "react-router-dom";
import PrivateRoute from "context/PrivateRoute";
import MainAdmin from "./MainAdmin";
import ViewOrganizations from "./ViewOrganizations";
import ViewPlugins from "./ViewPlugins";
import ViewPluginsRegister from "./ViewPluginsRegister";
import PluginImport from "./plugins/import/PluginImport";
import PlgunExport from "./plugins/export/PluginExport";
import ViewUsers from "./ViewUsers";
import ViewUsersTelegram from "./ViewUsersTelegram";
import PluginList from "./plugins/import/PluginList";
import PluginEdit from "./plugins/import/PluginEdit";

// prettier-ignore
const RoutesAdministration = () => {

    return (
        <>
            <Route path="administration" element={<PrivateRoute role="admin"><MainAdmin /></PrivateRoute>} />
            <Route path="administration/organizations" element={<PrivateRoute role="admin"><ViewOrganizations /></PrivateRoute>} />
            <Route path="administration/plugins/" element={<PrivateRoute role="superuser"><ViewPlugins /></PrivateRoute>} />
            <Route path="administration/plugins/register" element={<PrivateRoute role="superuser"><ViewPluginsRegister /></PrivateRoute>} />
            <Route path="administration/plugins/import/:token" element={<PrivateRoute role="superuser"><PluginImport /></PrivateRoute>} />
            <Route path="administration/plugins/export/:token" element={<PrivateRoute role="superuser"><PlgunExport /></PrivateRoute>} />
            <Route path="administration/plugins/list/:token" element={<PrivateRoute role="superuser"><PluginList /></PrivateRoute>} />
            <Route path="administration/plugins/edit/:token" element={<PrivateRoute role="superuser"><PluginEdit /></PrivateRoute>} />
            <Route path="administration/users" element={<PrivateRoute role="admin"><ViewUsers /></PrivateRoute>} />
            <Route path="administration/users-telegram" element={<PrivateRoute role="admin"><ViewUsersTelegram /></PrivateRoute>} />

        </>
    )
}
export default RoutesAdministration;
